'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styles = {
  "ActivatorWrapper": "Polaris-TopBar-Menu__ActivatorWrapper",
  "Activator": "Polaris-TopBar-Menu__Activator",
  "Activator-userMenu": "Polaris-TopBar-Menu__Activator--userMenu",
  "Section": "Polaris-TopBar-Menu__Section"
};

exports.default = styles;
